import navigateTrigger from '@coolblue-development/ga4-events/triggers/SegmentNavigation/navigateTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { HamburgerEventFeature } from '../HamburgerMenu.types.js';
export default function useHamburgerMenuTrackingEvents() {
    const { trackEvent } = useAnalytics();
    const trackSelect = ({ isCrossLink, index, totalIndices, url, redirect }) => {
        const subFeature = isCrossLink
            ? HamburgerEventFeature.CROSS_LINKS
            : HamburgerEventFeature.GENERAL_NAVIGATION;
        trackEvent(navigateTrigger({
            sub_feature: subFeature,
            index: index + 1, // 1-based index for tracking
            total_indices: totalIndices,
            url,
            redirect,
        }));
    };
    return { trackSelect };
}
//# sourceMappingURL=useHamburgerMenuTrackingEvents.js.map